import { Component, EventEmitter, OnInit, Output, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalComponent } from '../modal/modal.component';
import { TextboxQuestion } from 'core/components/forms';

const GAMELEARN_NAME = 'Gamelearn';
@Component({
  selector: 'lms-personalized-email',
  templateUrl: './personalized-email.component.html',
  styleUrls: ['./personalized-email.component.scss']
})
export class PersonalizedEmailComponent implements OnInit {
  @Output() sendEmail = new EventEmitter<Object>();
  @Input() count: number;
  @Input() adminData: any;
  @ViewChild('modal', { static: false }) public modal: ModalComponent;

  public body: string = '';
  public title: string = '';
  public fromName: string = '';
  public isAutoSend: boolean = false;
  public nameQuestion: TextboxQuestion;
  public titleQuestion: TextboxQuestion;
  constructor(public router: Router) {}

  ngOnInit() {
    this.fromName = `${this.adminData.fullName} (${this.clientName})`;
  }

  openModal() {
    this.title = '';
    this.createQuestions();
    this.modal.open();
  }

  closeModal() {
    this.nameQuestion = null;
    this.titleQuestion = null;
    this.modal.close();
  }

  createQuestions() {
    this.nameQuestion = new TextboxQuestion({
      key: 'name',
      type: 'text',
      label: 'nouns.fromName',
      value: this.fromName,
      validators: { required: true },
      eventHandlers: {
        onChange: (value) => {
          this.fromName = value;
        }
      }
    });

    this.titleQuestion = new TextboxQuestion({
      key: 'title',
      type: 'text',
      label: 'actions.subjectMail',
      value: this.title,
      validators: { required: true },
      eventHandlers: {
        onChange: (value) => {
          this.title = value;
        }
      }
    });
  }

  onWysiwygValueChanged(data: { detail: { value: string } }) {
    let text = data.detail.value;
    text = text.replace(/<img[^>"']*((("[^"]*")|('[^']*'))[^"'>]*)*>/, '');
    this.body = text;
  }

  preview() {
    const url = this.router.serializeUrl(this.router.createUrlTree([`/preview`]));
    localStorage.setItem('personalizedHtml', this.body);
    window.open(url, '_blank');
  }

  confirm() {
    const email = {
      body: this.body,
      title: this.title,
      autosend: this.isAutoSend,
      fromName: this.fromName
    };
    this.sendEmail.emit(email);
    this.closeModal();
  }

  get checkDisable() {
    return !this.body.replace(/<[^>]*>?/gm, '').trim() || !this.title.trim() || !this.fromName.trim();
  }

  get clientName() {
    if (this.adminData.clients) {
      const currentClient = this.adminData.clients.find(
        (client) => this.adminData.selectedClientId === client.clientId
      );
      return currentClient.name;
    }
    return GAMELEARN_NAME;
  }
}
